import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const XIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 20 20", width: sizePx, style: styles, ...rest },
        React.createElement("path", { d: "M3.5 3l6.56 6.56M13.33 12.67l2.96 2.95M3.59 16.03l13.1-13.1", stroke: color, strokeWidth: "2", strokeLinecap: "round" })));
};
export default XIcon;
//# sourceMappingURL=index.js.map